import { supabase } from './supabase';

/** POST to a Supabase Edge Function with anon apikey + user JWT (required when verify_jwt = true). */
export async function supabaseEdgePost<T = Record<string, unknown>>(
  functionName: string,
  body: Record<string, unknown>,
): Promise<{ data: T | null; error: string | null; status: number }> {
  const base = process.env.REACT_APP_SUPABASE_URL?.replace(/\/$/, '');
  const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;
  if (!base) return { data: null, error: 'Supabase URL not configured', status: 0 };
  if (!anon) return { data: null, error: 'Supabase anon key not configured', status: 0 };

  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) return { data: null, error: 'Sign in required', status: 401 };

  const post = async (token: string) =>
    fetch(`${base}/functions/v1/${functionName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: anon,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

  let res = await post(session.access_token);
  if (res.status === 401) {
    await supabase.auth.refreshSession();
    const { data: { session: next } } = await supabase.auth.getSession();
    if (next?.access_token) res = await post(next.access_token);
  }

  const parsed = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) {
    return {
      data: null,
      error: parsed.error || `Request failed (${res.status})`,
      status: res.status,
    };
  }
  return { data: parsed, error: null, status: res.status };
}
